import { gql } from "@apollo/client";

export const CREATE_CLIENT_INTEGRATION = gql`
  mutation CreateClientIntegration($input: CreateClientIntegrationInput!) {
    createClientIntegration(input: $input) {
      integration {
        mrn
        token
        name
        status
        created
        lastCheckin
        type
        messages {
          message
          status
        }
        configurationOptions {
          ... on K8sConfigurationOptions {
            scanNodes
            scanNodesStyle
            scanWorkloads
            scanDeploys
            certificateManager
            scanPublicImages
            namespaceAllowList
            namespaceDenyList
          }
          ... on AWSConfigurationOptions {
            region
            isOrganization
            snsEndpoint
            originAWSAccountId
            cloudFormationTemplateUrl
            cloudFormationQuickcreateUrl
            useWif
            scanConfiguration {
              accountScan
              ec2Scan
              ecrScan
              ecsScan
              cronScaninHours
              ec2ScanOptions {
                ebsVolumeScan
                instanceConnect
                instanceIdsFilter
                excludedInstanceIdsFilter
                regionsFilter
                excludedRegionsFilter
                ssm
                tagsFilter
                excludedTagsFilter
              }
              vpcConfiguration {
                CIDR
                vpcFlavour
                vpcTag {
                  key
                  value
                }
              }
            }
          }
          ... on HostedAwsConfigurationOptions {
            accessKeyId
            role
            wifAudience
            wifRoleArn
            wifSubject
          }
          ... on AgentOptions {
            id
            version
            notes
            platform {
              name
              release
              arch
              kind
              runtime
            }
            hostname
            ipaddress
          }
          ... on AzureConfigurationOptions {
            tenantId
            clientId
            subscriptionsWhitelist
            subscriptionsBlacklist
            scanVms
          }
          ... on Ms365ConfigurationOptions {
            tenantId
            clientId
          }
          ... on MicrosoftDefenderConfigurationOptions {
            tenantId
            clientId
            subscriptionsAllowlist
            subscriptionsDenylist
            secretType
            createAssets
            mondooEnrichment
          }
          ... on GcpConfigurationOptions {
            projectId
            organizationId
            discoverAll
            wifAudience
            wifServiceAccountEmail
            wifSubject
          }
          ... on OktaConfigurationOptions {
            organization
          }
          ... on GcsBucketConfigurationOptions {
            output
            bucket
          }
          ... on GitlabConfigurationOptions {
            group
            type
            discoverGroups
            discoverProjects
            discoverTerraform
            discoverK8sManifests
            baseUrl
          }
          ... on GithubConfigurationOptions {
            owner
            repository
            githubOrg: organization
            githubType: type
            reposAllowList
            reposDenyList
            githubDiscoverK8sManifests: discoverK8sManifests
            githubDiscoverTerraform: discoverTerraform
            enterpriseUrl
          }
          ... on GoogleWorkspaceConfigurationOptions {
            customerId
            impersonatedUserEmail
          }
          ... on SlackConfigurationOptions {
            placeholder
          }
          ... on PostgresConfigurationOptions {
            host
            port
            database
            user
          }
          ... on OciConfigurationOptions {
            tenancyOcid
            userOcid
            region
            fingerprint
          }
          ... on HostConfigurationOptions {
            discoverSubdomains
            host
            http
            https
          }
          ... on EmailConfigurationOptions {
            autoCreateTickets
            recipients {
              name
              email
              isDefault
              referenceUrl
            }
          }
          ... on ShodanConfigurationOptions {
            token
            targets
          }
          ... on ZendeskConfigurationOptions {
            subdomain
            email
            autoCloseTickets
            autoCreateTickets
            customFields {
              id
              value
            }
          }
          ... on SentinelOneConfigurationOptions {
            host
            account
            secretType
            createAssets
            mondooEnrichment
          }
          ... on CrowdstrikeFalconConfigurationOptions {
            clientId
            cloud
            memberCID
            createAssets
            mondooEnrichment
          }
          ... on SecurityPipelineGithubConfigurationOptions {
            appInstallationLink
            publicKey
            repositories {
              link
              fullName
              spaceMrn
            }
          }
          ... on WebhookConfigurationOptions {
            autoCreateTickets
            autoCloseTickets
            url
          }
          ... on ServiceNowConfigurationOptions {
            instanceUrl
            clientId
            autoCloseTickets
            autoCreateTickets
            userEmail
          }
        }
      }
    }
  }
`;
